(function($){
    $(function(){

      // Mobile Navigation - Add class to promo list items
      $('.mobile-menu .mega-menu-promotion').parent().addClass('parent-link-promotion');
      $('.mobile-menu .parent-link-promotion').wrapAll('<div class="mobile-promotions"></div)');


      // Desktop Navigation - Add class to promo list items
      $('.thb-full-menu .mega-menu-promotion').parent().addClass('promotion');


      // Collection Tabs - Make all product cards same height
      var flickityHeight = $('.collection-tabs .flickity-viewport').height();
      $('.collection-tabs .product-card').height(flickityHeight);


    });

})(jQuery);